import { Suspense, ReactNode, useState } from 'react';
import { CssBaseline, Box, useMediaQuery, useTheme } from '@mui/material';
import { Error, Loading } from 'react-admin';
import { ErrorBoundary } from 'react-error-boundary';

import Header from './Header';
import Sidebar from './Sidebar';
import ChatBotWidget, { ChatBotProvider } from './ChatBotWidget';

const DRAWER_WIDTH = 240;

export const Layout = ({ children }: { children: ReactNode }) => {
    const [mobileOpen, setMobileOpen] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const handleDrawerClose = () => {
        setMobileOpen(false);
    };

    return (
        <ChatBotProvider>
            <Box sx={{ display: 'flex' }}>
                <CssBaseline />
                <Header onMenuClick={handleDrawerToggle} />
                <Sidebar open={mobileOpen} onClose={handleDrawerClose} />
                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        p: 3,
                        pb: 10,
                        mt: 8,
                        width: isMobile
                            ? '100%'
                            : `calc(100% - ${DRAWER_WIDTH}px)`,
                        transition: theme.transitions.create(
                            ['margin', 'width'],
                            {
                                easing: theme.transitions.easing.sharp,
                                duration:
                                    theme.transitions.duration.leavingScreen,
                            }
                        ),
                    }}
                >
                    <Box sx={{ width: '100%' }}>
                        <main id="main-content">
                            <ErrorBoundary FallbackComponent={Error}>
                                <Suspense fallback={<Loading />}>
                                    {children}
                                </Suspense>
                            </ErrorBoundary>
                        </main>
                    </Box>
                </Box>
                <ChatBotWidget />
            </Box>
        </ChatBotProvider>
    );
};
